export default "__VITE_ASSET__BwmiY5bX__"